import { gql } from "@apollo/client";

export default gql`
  mutation SetGroupNewsworthy($id: ObjectId!, $newsworthy: [GroupNewsworthyItemInput!]!) {
    setGroupNewsworthy(id: $id, newsworthy: $newsworthy) {
      _id
      newsworthy {
        title
        siteName
        favicon
        url
        description
      }
    }
  }
`;
